import { InformationCircleIcon } from '@heroicons/react/20/solid';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { useIsHydrated } from '../hooks/useIsHydrated';
import { Column, Row } from './Section';

export const ServerTimezoneAlert = () => {
  const isHydrated = useIsHydrated();

  const showTimezoneAlert = useMemo(
    () =>
      isHydrated &&
      DateTime.now().zoneName !== process.env.NEXT_PUBLIC_SERVER_TIMEZONE,
    [isHydrated],
  );

  return showTimezoneAlert ? (
    <div className="rounded-md bg-blue-50 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <InformationCircleIcon
            className="h-5 w-5 text-blue-400"
            aria-hidden="true"
          />
        </div>
        <div className="ml-3 flex-1 md:flex md:justify-between">
          <p className="text-sm text-blue-700">
            Times are displayed in the Eastern Time Zone
          </p>
        </div>
      </div>
    </div>
  ) : null;
};
